import { useCallbackRef } from '@eigtech/ui/hooks/use-callback-ref'
import { useEffect } from 'react'
import { useWakeLock } from 'react-screen-wake-lock'
import { useShallow } from 'zustand/shallow'
import { MeetingState, useMeetingStore } from './MeetingState'

const stateSelector = ({ chimeMeeting }: MeetingState) => chimeMeeting

export function WakeLockHandler() {
  const chimeMeeting = useMeetingStore(useShallow(stateSelector))

  const { request, release } = useWakeLock()

  const requestWakeLock = useCallbackRef(request)
  const releaseWakeLock = useCallbackRef(release)

  useEffect(() => {
    if (chimeMeeting) {
      requestWakeLock()
    }

    return () => {
      releaseWakeLock()
    }
  }, [chimeMeeting, releaseWakeLock, requestWakeLock])

  return <></>
}
